import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.company.overview');
import { OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-company-overview',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.widget.company.overview/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

.notion-page {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 64px;
  background: #fff;
}

/* ── Notion Cell ── */
.notion-cell {
  border: 1px solid #e4e4e7;
  border-radius: 12px;
  overflow: hidden;
  transition: box-shadow 0.15s;
}
.notion-cell:hover {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.notion-cell-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #e4e4e7;
  background: #fafafa;
}

.notion-cell-body {
  padding: 12px 16px;
}

/* ── Toggle Icon ── */
.notion-toggle-icon {
  display: inline-block;
  transition: transform 0.15s;
  font-size: 12px;
  color: #a1a1aa;
}
.notion-toggle-icon.collapsed {
  transform: rotate(-90deg);
}

/* ── Properties ── */
.notion-prop-row {
  display: flex;
  align-items: center;
  min-height: 36px;
  padding: 4px 0;
}

.notion-prop-label {
  width: 140px;
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 500;
  color: #71717a;
}

.notion-prop-value {
  flex: 1;
  font-size: 13px;
  color: #27272a;
}

.notion-prop-editable {
  cursor: pointer;
  border-radius: 4px;
  padding: 2px 6px;
  margin: -2px -6px;
  transition: background 0.12s;
}
.notion-prop-editable:hover {
  background: #f4f4f5;
}

.notion-edit-input {
  width: 100%;
  font-size: 13px;
  padding: 4px 8px;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  outline: none;
}
.notion-edit-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

/* ── Section Divider ── */
.notion-section-divider {
  display: flex;
  align-items: center;
  gap: 12px;
}
.notion-section-divider::before, .notion-section-divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #e4e4e7;
}
.notion-section-divider span {
  font-size: 12px;
  font-weight: 600;
  color: #a1a1aa;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

/* ── Stats Cards ── */
.notion-stat-card {
  display: block;
  padding: 16px;
  border: 1px solid #e4e4e7;
  border-radius: 12px;
  background: #fff;
  transition: all 0.15s;
  text-decoration: none;
}
.notion-stat-card:hover {
  border-color: #d4d4d8;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* ── Overview Editor Area ── */
.overview-editor-area {
  min-height: 200px;
  border: 1px solid #e4e4e7;
  border-radius: 12px;
  overflow: hidden;
}
.overview-editor-area:focus-within {
  border-color: #d4d4d8;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.06);
}

/* ── Sub-page List ── */
.subpage-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.subpage-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 1px solid #f4f4f5;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.12s;
}
.subpage-card:hover {
  background: #f9fafb;
  border-color: #e4e4e7;
}

/* ── Sub-page Cover ── */
.subpage-cover {
  height: 200px;
  background-size: cover;
  background-position: center;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
}

.subpage-cover-edit {
  min-height: 32px;
}

/* ── Sub-page View ── */
.subpage-view {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 64px;
}

.subpage-content {
  padding: 0;
}

/* ── Sub-page Edit ── */
.subpage-edit {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 64px;
}

.subpage-editor-area {
  min-height: 400px;
  border: 1px solid #e4e4e7;
  border-radius: 12px;
  overflow: hidden;
}
.subpage-editor-area:focus-within {
  border-color: #d4d4d8;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.06);
}

/* ── Icon Picker ── */
.icon-picker-dropdown {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 50;
  background: #fff;
  border: 1px solid #e4e4e7;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  width: 280px;
}
.group\/icon:hover .icon-picker-dropdown {
  display: block;
}

/* ── CK/HTML content display ── */
.ck-view-content img {
  max-width: 100%;
  border-radius: 4px;
}
.ck-view-content p {
  margin: 0;
}
.ck-view-content a {
  color: #3b82f6;
  text-decoration: underline;
}`],
})
export class PortalLpsysadminWidgetCompanyOverviewComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }

    @Input() company: any;
    @Input() category: any = 'investment';
    @Output() companyChange = new EventEmitter<any>();

    public news: any[] = [];
    public investments: any[] = [];
    public investmentStatus: any = null;
    public valuationTest: any = { manual_company_value: null, manual_our_value: null, memo: '' };
    public counts: any = { qna: 0, comment: 0, news: 0 };
    public logoTimestamp: number = Date.now();

    public editing: any = {};
    public editValues: any = {};

    public businessAreaSuggestions: string[] = [];
    public filteredSuggestions: string[] = [];
    public showSuggestions: boolean = false;

    // Overview content (single Tiptap document)
    public overviewContent: any = null;
    public overviewLoaded: boolean = false;
    private autoSaveTimer: any = null;

    // Properties
    public propertiesCollapsed: boolean = false;

    // Sub-pages (backed by company_comment table = 기업관리 이력)
    public subPages: any[] = [];
    public subPageMode: string = 'none'; // 'none' | 'view' | 'edit'
    public selectedSubPage: any = null;
    public editSubPageTitle: string = '';
    public editSubPageIcon: string = '📄';
    public editSubPageContent: any = null;
    public editSubPageCover: string = '';
    public editSubPageGrade: string = '';
    public isNewSubPage: boolean = false;
    private subPageAutoSaveTimer: any = null;

    public gradeOptions = [
        { value: '', label: '-', color: '' },
        { value: 'S', label: 'S', color: 'bg-blue-100 text-blue-700 border-blue-300' },
        { value: 'A', label: 'A', color: 'bg-emerald-100 text-emerald-700 border-emerald-300' },
        { value: 'B', label: 'B', color: 'bg-yellow-100 text-yellow-700 border-yellow-300' },
        { value: 'C', label: 'C', color: 'bg-orange-100 text-orange-700 border-orange-300' },
        { value: 'D', label: 'D', color: 'bg-red-100 text-red-700 border-red-300' },
    ];

    // Data summary (7 categories)
    public dataSummary: any = {};
    public dataSummaryLoaded: boolean = false;

    public pageIcons: string[] = ['📄', '📝', '📋', '📊', '📈', '📉', '💰', '🏢', '🎯', '💡', '🔍', '📌', '⭐', '🚀', '💼', '📁', '🗂️', '📑', '🔑', '💎'];

    public async ngOnInit() {
        await this.service.init();
        this.normalizeCompany();
        if (this.company && this.company.id) {
            await this.loadSafely(() => this.loadRecent());
            await this.loadSafely(() => this.loadOverview());
            await this.loadSafely(() => this.loadSubPages());
            await this.loadSafely(() => this.loadDataSummary());
        }
        await this.loadSafely(() => this.loadBusinessAreas());
        await this.service.render();
    }

    private normalizeCompany() {
        if (!this.company || typeof this.company !== 'object') this.company = { extra: {} };
        if (!this.company.extra || typeof this.company.extra !== 'object' || Array.isArray(this.company.extra)) {
            this.company.extra = {};
        }
        if (this.company.extra.contacts != null && !Array.isArray(this.company.extra.contacts)) {
            this.company.extra.contacts = [];
        }
    }

    private async loadSafely(loader: () => Promise<any>) {
        try {
            await loader();
        } catch (e) {
            console.error('Failed to load company overview section', e);
        }
    }

    ngOnDestroy() {
        this.clearAutoSave();
        this.clearSubPageAutoSave();
    }

    // ── Business Areas ──

    public async loadBusinessAreas() {
        const { code, data } = await wiz.call("load_business_areas");
        if (code === 200) {
            this.businessAreaSuggestions = data.areas || [];
        }
    }

    public onBusinessAreaInput(value: string) {
        if (!value || !value.trim()) {
            this.filteredSuggestions = [];
            this.showSuggestions = false;
            return;
        }
        const lower = value.toLowerCase();
        this.filteredSuggestions = this.businessAreaSuggestions.filter(
            (s) => s.toLowerCase().includes(lower) && s.toLowerCase() !== lower
        );
        this.showSuggestions = this.filteredSuggestions.length > 0;
    }

    public async selectBusinessArea(area: string) {
        this.editValues.business_area = area;
        this.showSuggestions = false;
        this.filteredSuggestions = [];
        await this.saveField('business_area');
    }

    public hideBusinessAreaSuggestions() {
        setTimeout(() => {
            this.showSuggestions = false;
            this.service.render();
        }, 200);
    }

    // ── Recent Data ──

    public async loadRecent() {
        const { code, data } = await wiz.call("recent", { company_id: this.company.id });
        if (code === 200) {
            this.news = data.news || [];
            this.investments = data.investments || [];
            this.investmentStatus = data.investment_status || null;
            this.counts = data.counts || { qna: 0, comment: 0, news: 0 };
        }
    }

    // ── Data Summary (7 categories) ──

    public async loadDataSummary() {
        const { code, data } = await wiz.call("data_summary", { company_id: this.company.id });
        if (code === 200) {
            this.dataSummary = data.summary || {};
        }
        this.dataSummaryLoaded = true;
    }

    public formatAmount(amount: number): string {
        if (!amount) return '0';
        if (amount >= 100000000) return (amount / 100000000).toFixed(1) + '억';
        if (amount >= 10000) return (amount / 10000).toFixed(0) + '만';
        return amount.toLocaleString();
    }

    public formatCurrency(amount: any): string {
        const value = Number(amount || 0);
        if (!value) return '-';
        if (Math.abs(value) >= 100000000) return (value / 100000000).toFixed(1) + '억원';
        return Math.round(value).toLocaleString() + '원';
    }

    public formatShares(value: any): string {
        const count = Number(value || 0);
        if (!count) return '-';
        return Math.round(count).toLocaleString() + '주';
    }

    public formatPercent(value: any): string {
        const num = Number(value || 0);
        if (!num) return '-';
        return num.toFixed(num < 1 ? 4 : 2).replace(/0+$/, '').replace(/\.$/, '') + '%';
    }

    public valuationHistory() {
        const rows = this.investmentStatus?.valuation_tests;
        return Array.isArray(rows) ? rows : [];
    }

    public valuationPreview() {
        const status = this.investmentStatus || {};
        const totalShares = Number(status.total_company_shares || 0);
        const ownedShares = Number(status.owned_shares || 0);
        const companyValue = Number(this.valuationTest.manual_company_value || 0);
        const ourValue = Number(this.valuationTest.manual_our_value || 0);

        if (ourValue > 0 && ownedShares > 0) {
            const price = ourValue / ownedShares;
            return {
                visible: true,
                basis: '우리 보유가치',
                price_per_share: price,
                company_value: totalShares > 0 ? price * totalShares : 0,
                our_value: ourValue,
            };
        }

        if (companyValue > 0 && totalShares > 0) {
            const price = companyValue / totalShares;
            return {
                visible: true,
                basis: '기업 현재가치',
                price_per_share: price,
                company_value: companyValue,
                our_value: ownedShares > 0 ? price * ownedShares : 0,
            };
        }

        return { visible: false, basis: '', price_per_share: 0, company_value: 0, our_value: 0 };
    }

    public async saveValuationTest() {
        if (!this.company?.id) return;
        const companyValue = Number(this.valuationTest.manual_company_value || 0);
        const ourValue = Number(this.valuationTest.manual_our_value || 0);
        if (companyValue <= 0 && ourValue <= 0) {
            this.service.alert.error('기업 현재가치 또는 우리 보유가치를 입력하세요.');
            return;
        }
        const { code, data } = await wiz.call('save_valuation_test', {
            company_id: this.company.id,
            data: JSON.stringify(this.valuationTest)
        });
        if (code === 200) {
            this.investmentStatus = data.investment_status;
            this.valuationTest = { manual_company_value: null, manual_our_value: null, memo: '' };
            this.service.alert.success('투자현황 테스트 기록을 저장했습니다.');
        } else {
            this.service.alert.error(data?.message || '저장에 실패했습니다.');
        }
        await this.service.render();
    }

    public formatDiff(diff: number): string {
        if (!diff && diff !== 0) return '';
        const prefix = diff > 0 ? '+' : '';
        return prefix + this.formatAmount(diff);
    }

    // ── Field Editing ──

    public async startEdit(field: string, value: string) {
        this.editing[field] = true;
        this.editValues[field] = value || '';
        await this.service.render();
    }

    public async saveField(field: string) {
        this.editing[field] = false;
        this.showSuggestions = false;
        const value = this.editValues[field];
        if (!this.company.extra) this.company.extra = {};
        this.company.extra[field] = value;
        const { code } = await wiz.call("update_field", {
            company_id: this.company.id,
            field: field,
            value: value
        });
        if (code === 200) {
            this.companyChange.emit(this.company);
        }
        await this.service.render();
    }

    // ── Logo ──

    public async uploadLogo() {
        let files = await this.service.file.select({ accept: 'image/*' });
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        let fd = new FormData();
        fd.append('upload', files[0]);
        let fdurl = '/file/upload';
        const { url } = await this.service.file.upload(fdurl, fd, async (percent: number) => { });
        const { code } = await wiz.call("update_logo", {
            company_id: this.company.id,
            logo_url: url
        });
        if (code === 200) {
            this.company.logo_image = url;
            this.logoTimestamp = Date.now();
            this.companyChange.emit(this.company);
        }
        await this.service.loading.hide();
        await this.service.render();
    }

    // ── Overview Content (Single Tiptap Editor) ──

    public async loadOverview() {
        const { code, data } = await wiz.call("load_overview", { company_id: this.company.id });
        if (code === 200) {
            this.overviewContent = data.content || null;
        }
        this.overviewLoaded = true;
    }

    public onOverviewContentChange(content: any) {
        this.overviewContent = content;
        this.clearAutoSave();
        this.autoSaveTimer = setTimeout(() => {
            this.saveOverview();
        }, 2000);
    }

    private async saveOverview() {
        this.clearAutoSave();
        await wiz.call("save_overview", {
            company_id: this.company.id,
            content: this.overviewContent ? JSON.stringify(this.overviewContent) : ''
        });
    }

    private clearAutoSave() {
        if (this.autoSaveTimer) {
            clearTimeout(this.autoSaveTimer);
            this.autoSaveTimer = null;
        }
    }

    // ── Sub Pages (= 기업관리 이력, backed by company_comment) ──

    public async loadSubPages() {
        const { code, data } = await wiz.call("load_subpages", { company_id: this.company.id });
        if (code === 200) {
            this.subPages = data.subpages || [];
        }
        // Update comment count from sub-pages length
        this.counts.comment = this.subPages.length;
    }

    public async openSubPage(page: any) {
        this.selectedSubPage = page;
        this.subPageMode = 'view';
        await this.service.render();
    }

    public async newSubPage() {
        this.isNewSubPage = true;
        this.editSubPageTitle = '';
        this.editSubPageIcon = '📄';
        this.editSubPageContent = null;
        this.editSubPageCover = '';
        this.editSubPageGrade = '';
        this.selectedSubPage = null;
        this.subPageMode = 'edit';
        await this.service.render();
    }

    public async editSubPage() {
        if (!this.selectedSubPage) return;
        this.isNewSubPage = false;
        this.editSubPageTitle = this.selectedSubPage.title || '';
        this.editSubPageIcon = this.selectedSubPage.icon || '📄';
        this.editSubPageContent = this.selectedSubPage.content || null;
        this.editSubPageCover = this.selectedSubPage.cover || '';
        this.editSubPageGrade = this.selectedSubPage.grade || '';
        this.subPageMode = 'edit';
        await this.service.render();
    }

    public async onSubPageContentChange(content: any) {
        this.editSubPageContent = content;
        this.clearSubPageAutoSave();
        this.subPageAutoSaveTimer = setTimeout(() => {
            this.saveSubPage(true);
        }, 3000);
    }

    public async saveSubPage(silent: boolean = false) {
        this.clearSubPageAutoSave();
        const { code, data } = await wiz.call("save_subpage", {
            company_id: this.company.id,
            page_id: this.isNewSubPage ? '' : (this.selectedSubPage?.id || ''),
            title: this.editSubPageTitle || '제목 없음',
            icon: this.editSubPageIcon,
            content: this.editSubPageContent ? JSON.stringify(this.editSubPageContent) : '',
            cover: this.editSubPageCover,
            grade: this.editSubPageGrade
        });
        if (code === 200) {
            await this.loadSubPages();
            const pageId = data.page_id;
            const found = this.subPages.find((p: any) => p.id === pageId);
            if (found) {
                this.selectedSubPage = found;
                this.isNewSubPage = false;
            }
            if (!silent) {
                this.subPageMode = 'view';
            }
        }
        await this.service.render();
    }

    public async cancelSubPageEdit() {
        this.clearSubPageAutoSave();
        if (this.isNewSubPage) {
            this.subPageMode = 'none';
            this.selectedSubPage = null;
        } else {
            this.subPageMode = 'view';
        }
        await this.service.render();
    }

    public async deleteSubPage(page?: any) {
        const target = page || this.selectedSubPage;
        if (!target) return;
        const res = await this.service.alert.show({
            title: '',
            message: '이 페이지를 삭제하시겠습니까?',
            cancel: '취소',
            actionBtn: 'error',
            action: '삭제',
            status: 'error'
        });
        if (!res) return;
        await wiz.call("delete_subpage", {
            company_id: this.company.id,
            page_id: target.id
        });
        await this.loadSubPages();
        this.subPageMode = 'none';
        this.selectedSubPage = null;
        await this.service.render();
    }

    public async backFromSubPage() {
        this.clearSubPageAutoSave();
        this.subPageMode = 'none';
        this.selectedSubPage = null;
        await this.service.render();
    }

    private clearSubPageAutoSave() {
        if (this.subPageAutoSaveTimer) {
            clearTimeout(this.subPageAutoSaveTimer);
            this.subPageAutoSaveTimer = null;
        }
    }

    public async uploadSubPageCover() {
        let files = await this.service.file.select({ accept: 'image/*' });
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        let fd = new FormData();
        fd.append('upload', files[0]);
        const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
        this.editSubPageCover = url;
        await this.service.loading.hide();
        await this.service.render();
    }

    public async removeSubPageCover() {
        this.editSubPageCover = '';
        await this.service.render();
    }

    // ── Helpers ──

    public renderHtml(content: string) {
        if (!content) return '';
        return this.sanitizer.bypassSecurityTrustHtml(content);
    }

    public linkMenu(menu: string) {
        const map: any = {
            meeting: 'meeting_company',
            review: 'review_company',
            investment: 'company',
            exit: 'exit_company',
            dropped: 'dropped_company'
        };
        const main = map[this.category] || 'company';
        return `/admin/invest/${main}/${this.company.id}/${menu}`;
    }

    public hasContent(key: string) {
        return this.company?.extra?.[key] && this.company.extra[key].trim().length > 0;
    }

    public getContacts() {
        const contacts = this.company?.extra?.contacts;
        return Array.isArray(contacts) ? contacts : [];
    }

    public toggleProperties() {
        this.propertiesCollapsed = !this.propertiesCollapsed;
        this.service.render();
    }

    public formatDate(date: string): string {
        if (!date) return '';
        return date.substring(0, 10);
    }

    public objectKeys(obj: any): string[] {
        if (!obj) return [];
        return Object.keys(obj);
    }

    public getSubPagePreview(page: any): string {
        if (!page.content) return '';
        let content = page.content;
        if (typeof content === 'string') {
            try {
                content = JSON.parse(content);
            } catch (e) {
                return content.substring(0, 80);
            }
        }
        const text = this.extractText(content);
        return text.length > 80 ? text.substring(0, 80) + '...' : text;
    }

    public getGradeStyle(grade: string): string {
        const map: any = {
            'S': 'bg-blue-100 text-blue-700 border border-blue-300',
            'A': 'bg-emerald-100 text-emerald-700 border border-emerald-300',
            'B': 'bg-yellow-100 text-yellow-700 border border-yellow-300',
            'C': 'bg-orange-100 text-orange-700 border border-orange-300',
            'D': 'bg-red-100 text-red-700 border border-red-300',
        };
        return map[grade] || '';
    }

    private extractText(node: any): string {
        if (!node) return '';
        if (node.text) return node.text;
        if (Array.isArray(node.content)) return node.content.map((n: any) => this.extractText(n)).join(' ');
        return '';
    }
}

export default PortalLpsysadminWidgetCompanyOverviewComponent;